import React from 'react'
import { observer } from 'mobx-react-lite'
import Input from '../../../../../../../../components/FormComponents/Input'

export default observer(function InstaStoryInsightForm({ formProps }) {
  const { handleBlur, handleChange, values, touched, errors } = formProps

  return (
    <div className='flex flex-col gap-2'>
      <div className="grid grid-cols-2 gap-2">
        <div>
          <Input
            overrideClassName="pl-4 h-8"
            topMargin={false}
            error={touched.story_sequence_count && errors.story_sequence_count}
            noLabelPadding
            label="Amount of Sequences"
            placeholder="Sequence Count"
            name='story_sequence_count'
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.story_sequence_count}
          />
        </div>
        <div>
          <Input
            overrideClassName="pl-4 h-8"
            topMargin={false}
            error={touched.story_first_sequence_reach && errors.story_first_sequence_reach}
            noLabelPadding
            label="First Sequence Reach"
            placeholder="First reach"
            name='story_first_sequence_reach'
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.story_first_sequence_reach}
          />
        </div>
        <div>
          <Input
            overrideClassName="pl-4 h-8"
            topMargin={false}
            error={touched.story_last_sequence_reach && errors.story_last_sequence_reach}
            noLabelPadding
            label="Last Sequence Reach"
            placeholder="Last reach"
            name='story_last_sequence_reach'
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.story_last_sequence_reach}
          />
        </div>
        <div>
          <Input
            overrideClassName="pl-4 h-8"
            topMargin={false}
            error={touched.story_first_sequence_impressions && errors.story_first_sequence_impressions}
            noLabelPadding
            label="First Sequence Impressions"
            placeholder="First impressions"
            name='story_first_sequence_impressions'
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.story_first_sequence_impressions}
          />
        </div>
        <div>
          <Input
            overrideClassName="pl-4 h-8"
            topMargin={false}
            error={touched.story_last_sequence_impressions && errors.story_last_sequence_impressions}
            noLabelPadding
            label="Last Sequence Impressions"
            placeholder="Last impressions"
            name='story_last_sequence_impressions'
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.story_last_sequence_impressions}
          />
        </div>
        <div>
          <Input
            overrideClassName="pl-4 h-8"
            topMargin={false}
            error={touched.clicks && errors.clicks}
            noLabelPadding
            label="Link clicks"
            placeholder="Clicks"
            name='clicks'
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.clicks}
          />
        </div>
        <div>
          <Input
            overrideClassName="pl-4 h-8"
            topMargin={false}
            error={touched.likes && errors.likes}
            noLabelPadding
            label="Likes"
            placeholder="Likes"
            name='likes'
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.likes}
          />
        </div>
        <div>
          <Input
            overrideClassName="pl-4 h-8"
            topMargin={false}
            error={touched.sticker_taps && errors.sticker_taps}
            noLabelPadding
            label="Sticker Taps"
            placeholder="Sticker Taps"
            name='sticker_taps'
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.sticker_taps}
          />
        </div>
        <div>
          <Input
            overrideClassName="pl-4 h-8"
            topMargin={false}
            error={touched.amount_likes && errors.amount_likes}
            noLabelPadding
            label="Amount Likes"
            placeholder="Amount Likes"
            name='amount_likes'
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.amount_likes}
          />
        </div>
        <div>
          <Input
            overrideClassName="pl-4 h-8"
            topMargin={false}
            error={touched.amount_comments && errors.amount_comments}
            noLabelPadding
            label="Amount Comments"
            placeholder="Amount Comments"
            name='amount_comments'
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.amount_comments}
          />
        </div>
      </div>
    </div>
  )
})
